import { Api, Http } from '../../../models/index';
import { CacheableResource } from '../CacheableResource';
import { CreateRequest } from '../CreateRequest';

export class GetApi extends CacheableResource<CacheableResource.Params, Api> {
    private createRequest = new CreateRequest();

    constructor(private http: Http) {
        super() /* istanbul ignore next */;
    }

    protected doExecute(): Promise<Api> {
        return this.http
            .request<Api>(
                this.createRequest.execute({
                    method: 'GET',
                    url: '/api'
                })
            )
            .then((response) => response.body!);
    }
}
